"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var date_1 = tslib_1.__importDefault(require("./components/date"));
var spinner_1 = tslib_1.__importDefault(require("./components/spinner"));
var context_1 = require("./context");
var types_1 = require("./types");
var text_1 = tslib_1.__importDefault(require("./components/text"));
var locale_1 = tslib_1.__importDefault(require("./locale"));
var virtual_table_1 = require("./virtual-table");
var window_1 = require("./hooks/window");
var StyledSelect = (0, styled_components_1.default)(antd_1.Select)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var DataTable = function (_a) {
    var _b, _c, _d, _e;
    var quickFilters = _a.quickFilters, _f = _a.records, records = _f === void 0 ? [] : _f, loading = _a.loading, onPaginate = _a.onPaginate, hasMore = _a.hasMore, onRow = _a.onRow, offsetTop = _a.offsetTop, defaultColumWidth = _a.defaultColumWidth;
    var tableCtx = (0, context_1.useTableContext)();
    var height = (0, window_1.useWindowSize)().height;
    var tableHeight = height ? (((_b = tableCtx.filtersObject) === null || _b === void 0 ? void 0 : _b.isOpen) ? height - (offsetTop + 125) : height - offsetTop) : 500;
    if (quickFilters) {
        tableHeight = height ? height - offsetTop : 500;
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(virtual_table_1.VirtualTable, { columns: mapColumns((_c = tableCtx.columnsObject) === null || _c === void 0 ? void 0 : _c.data), dataSource: mapRecords(records, (_d = tableCtx.columnsObject) === null || _d === void 0 ? void 0 : _d.data), originalRecords: records, loading: loading, height: tableHeight, onPaginate: onPaginate, hasMore: hasMore, onClickRow: onRow, sortable: tableCtx.sortable, onReSizeColumn: (_e = tableCtx === null || tableCtx === void 0 ? void 0 : tableCtx.columnsObject) === null || _e === void 0 ? void 0 : _e.onResize, defaultColumWidth: defaultColumWidth }),
            loading && react_1.default.createElement(spinner_1.default, null))));
};
exports.default = DataTable;
var mapColumns = function (columns) {
    var res = [];
    columns === null || columns === void 0 ? void 0 : columns.forEach(function (col) {
        if (col.isVisible) {
            res.push({
                Header: col.title || "",
                accessor: col.key,
                render: col.render,
                width: col.width || 0,
                resizable: col === null || col === void 0 ? void 0 : col.canResize,
                sortable: col === null || col === void 0 ? void 0 : col.isSortable,
                fixed: col === null || col === void 0 ? void 0 : col.fixed,
            });
        }
    });
    return res;
};
var mapRecords = function (records, columns) {
    if (records === void 0) { records = []; }
    var res = [];
    records.forEach(function (record) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var row;
        return tslib_1.__generator(this, function (_a) {
            row = {};
            columns === null || columns === void 0 ? void 0 : columns.forEach(function (column) {
                var _a;
                var index = column.dataIndex;
                var item = (0, lodash_1.get)(record, index);
                if ((0, lodash_1.isEmpty)(column.dataIndex)) {
                    item = record;
                }
                if (item || column.type === types_1.DATA_TYPE.BOOLEAN || column.type === types_1.DATA_TYPE.NUMBER) {
                    var celldata = void 0;
                    switch (column.type) {
                        case types_1.DATA_TYPE.TEXT:
                        case types_1.DATA_TYPE.ARRAY:
                            celldata = react_1.default.createElement(text_1.default, { value: item, canCopy: column.canCopy });
                            break;
                        case types_1.DATA_TYPE.NUMBER:
                            celldata = item && item.toString();
                            break;
                        case types_1.DATA_TYPE.BOOLEAN:
                            celldata = react_1.default.createElement(antd_1.Tag, { color: item ? "green" : "orange" }, item ? locale_1.default.true : locale_1.default.false);
                            break;
                        case types_1.DATA_TYPE.DATETIME:
                            celldata = react_1.default.createElement(date_1.default, { date: item });
                            break;
                        case types_1.DATA_TYPE.CHOICE:
                            celldata = (react_1.default.createElement(StyledSelect, { showSearch: true, defaultValue: item, placeholder: locale_1.default.selectSearchTitle, optionFilterProp: 'children', filterOption: function (input, option) { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.children) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0; }, filterSort: function (optionA, optionB) {
                                    return optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase());
                                }, onClick: function (e) {
                                    e.stopPropagation();
                                } }, (_a = column.options) === null || _a === void 0 ? void 0 : _a.map(function (option, i) {
                                return (react_1.default.createElement(antd_1.Select.Option, { key: i, value: option.value, disabled: true }, option.label));
                            })));
                            break;
                        case types_1.DATA_TYPE.CUSTOM:
                            celldata = item;
                            break;
                        default:
                            celldata = "-";
                    }
                    row[column.key] = celldata;
                }
                else {
                    row[column.key] = column.defaultIfNull;
                }
            });
            res.push(row);
            return [2 /*return*/];
        });
    }); });
    return res;
};
var templateObject_1;
//# sourceMappingURL=table.js.map